import React, { useRef } from "react";
import { BottomBox, Container, TopBox, Wrapper } from "./style";
import { useNavigate } from "react-router";
import { useNavigatePage } from "hooks/useNavigatePage";
import { useScrollFadeIn } from "hooks/useScrollFadeIn";
const Com3 = ({ t }) => {
  const nav = useNavigatePage();
  const ref1 = useRef();
  const ref2 = useRef();
  const ref3 = useRef();

  useScrollFadeIn(ref1, ref2, ref3);
  return (
    <Wrapper>
      <TopBox>
        <span>{t("3-1")}</span>
        <span>{t("3-2")}</span>
        <span>{t("3-3")}</span>
        <span onClick={() => nav("/sketch_drop")}>{t("3-4")}</span>
      </TopBox>
      <BottomBox>
        <Container ref={ref1} className="fade-in">
          <div>
            <img
              loading="lazy"
              src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/6d9f2582WhatIsCreator_3.svg"
              alt=""
            />
          </div>
          <span>{t("3-5")}</span>
          <span>
            <span>{t("3-6")}</span>
            <span>{t("3-7")}</span>
          </span>
        </Container>
        <Container ref={ref2} className="fade-in">
          <div>
            <img
              loading="lazy"
              src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/089141b3WhatIsCreator_4.svg"
              alt=""
            />
          </div>
          <span>{t("3-8")}</span>
          <span>
            <span>{t("3-9")}</span>
            <span> {t("3-10")}</span>
          </span>
        </Container>
        <Container ref={ref3} className="fade-in">
          <div>
            <img
              loading="lazy"
              src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/c6361575WhatIsCreator_5.svg"
              alt=""
            />
          </div>
          <span>{t("3-11")}</span>
          <span>
            <span>{t("3-12")}</span>
            <span>{t("3-13")}</span>
          </span>
        </Container>
      </BottomBox>
    </Wrapper>
  );
};

export default Com3;
